// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"44fcd2c27f766ffb","6199":"2273c05fc0e19a3f","8427":"727973242bb33abd","8482":"752671964220d94d"}[chunkId] + ".css";
};